module.exports = __webpack_public_path__ + "img/stella-logo.bc39fa01.png";